import {styled} from '@linaria/react';
import {
  mediaDesktopAndUp,
  mediaLargeScreens,
  mediaTabletAndUp,
} from '../../../constants/customMedia';
import {SPACING} from '../../../constants/sizing';

export const ROW_SECTION_MAX_WIDTH = 1800;

export const ROW_SECTION_PADDING = {
  tabletAndUp: SPACING['X.Xl'],
  desktopAndUp: '30px',
  largeScreens: SPACING['X.Xl6'],
};

export interface RowSectionProps {
  dataTestId?: string;
  pullStart?: boolean;
  pullEnd?: boolean;
  centerContent?: boolean;
  constrained?: boolean;
}

export const RowSection = styled.section<RowSectionProps>`
  width: 100%;
  margin-inline: auto;
  max-width: ${ROW_SECTION_MAX_WIDTH}px;

  display: ${({centerContent}) => (centerContent ? 'flex' : 'block')};
  justify-content: ${({centerContent}) => (centerContent ? 'center' : '')};

  --row-section-padding: 0px;

  @media ${mediaTabletAndUp} {
    --row-section-padding: ${({constrained}) =>
      constrained ? '' : ROW_SECTION_PADDING.tabletAndUp};
  }

  @media ${mediaDesktopAndUp} {
    --row-section-padding: ${({constrained}) =>
      constrained ? '' : ROW_SECTION_PADDING.desktopAndUp};
  }

  @media ${mediaLargeScreens} {
    --row-section-padding: ${({constrained}) =>
      constrained ? '' : ROW_SECTION_PADDING.largeScreens};
  }

  padding-left: ${({pullStart}) =>
    pullStart ? '0' : 'var(--row-section-padding)'};
  padding-right: ${({pullEnd}) =>
    pullEnd ? '0' : 'var(--row-section-padding)'};
`;
